import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetMasterStudentLessonList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterStudentLessonView/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateMasterScheduleLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterStudentLessonView/Create");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class UpdateMasterScheduleLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterStudentLessonView/Update");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

export {
  GetMasterStudentLessonList,
  CreateMasterScheduleLesson,
  UpdateMasterScheduleLesson,
};
